/** Total weight across freight items (matches server loadMetrics weight sum). */
export function totalLtlItemWeight(items: Array<{ weight?: number | null }>): number {
  return items.reduce((sum, item) => {
    const n = Number(item.weight);

    return sum + (Number.isFinite(n) ? n : 0);
  }, 0);
}

export function ltlWeightLimitWarning(
  totalWeight: number,
  maxWeight: number | null | undefined
): string | null {
  if (maxWeight == null || !Number.isFinite(maxWeight)) return null;
  if (!(totalWeight > maxWeight)) return null;
  return `Exceeds quoting limits: weight ${totalWeight} > ${maxWeight}.`;
}
